import React, { useRef, useState } from 'react';

import { cleanText } from '../utils/cleanText';
import { capture, sizeBucket } from '../utils/telemetry';

const Main = () => {
  const title = 'Welcome to the future';
  const description = 'This is the future now';
  const action = 'Convert';

  const [inputValue, setInputValue] = useState('');
  const [outputValue, setOutputValue] = useState('');

  const hasStartedInput = useRef(false);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    if (value === '') {
      capture('input_cleared');
    } else if (!hasStartedInput.current) {
      hasStartedInput.current = true;
      capture('input_started');
    }
    setInputValue(value);
  };

  const handleSubmit = () => {
    const size = sizeBucket(inputValue.length);
    capture('convert_clicked', { size });
    if (outputValue !== '') {
      capture('convert_repeated');
    }
    const result = cleanText(inputValue);
    if (result === '') {
      capture('convert_empty', { size });
    } else {
      capture('convert_completed', { changed: result !== inputValue, size });
    }
    setOutputValue(result);
  };

  return (
    <div className="main">
      <div className="main-content">
        <div className="main-intro">
          <span className="main-title">{title}</span>
          <span className="main-description">{description}</span>
        </div>
        <input
          className="main-input"
          placeholder="Enter text here"
          type="text"
          value={inputValue}
          onChange={handleInputChange}
        />
        <button
          className="main-action"
          onClick={handleSubmit}
        >
          {action}
        </button>
        {outputValue !== '' && (
          <output className="main-output">{outputValue}</output>
        )}
      </div>
    </div>
  );
};

export default Main;
